import React, { useEffect, useState } from "react";
import Footer from "../../components/website/Footer";
import HeaderConferences from "../../components/website/HeaderConferences";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/Breadcrumbs";
import axios from "axios";
import {ThreeDots} from "react-loader-spinner";
import {NotificationManager} from "react-notifications";
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

const center = [50.09193349182558, 14.474597589444645];



function Contact() {
  const [isLoading, setIsLoading] = useState(false);




  const handleEmail = (event) => {
    const { name, value } = event.target;
    setSlackBody((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const slackBodyInitState = {
    from: "contact form",
    name: "",
    email: "",
    subject: "",
    message: ""
  };

  const [slackBody, setSlackBody] = useState(slackBodyInitState);

  const postMessageToSlack = async (e, type) => {
    e.preventDefault();
    let url = '';
    if (window.location.hostname === 'localhost') {
      //url = 'https://localhost:7264/';
      url = 'https://api.bcf-events.com/';
    }
    if (window.location.hostname === 'green-desert-021865b10.3.azurestaticapps.net'
        || window.location.hostname === 'brave-dune-00ae5aa10.3.azurestaticapps.net'
        || window.location.hostname === 'new.bcf-events.com'
        || window.location.hostname === 'bcf-events.com'
    ) {
      url = 'https://api.bcf-events.com/';
    }

    try {
      let data = {};
      data = slackBody
      const response = await axios.post(`${url}User/slack/${type}`, data);
      console.log('response from endpoint: ', response);
      NotificationManager.success('Thank you for your request!\n', 'Success', 5000);
      setIsLoading(true);
      setTimeout(() => {
        window.location.reload(false);
      }, 3000);
    } catch (error) {
      console.error("Error sending message to Slack:", error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
      <div>
        <HeaderConferences />
        <main>
          <section>
            <div className="container">
              <div className="breadcrumbs-about breadcrumbs-add">
                <ul>
                  <li className="andThisStyle title-breadcrumbs">
                    <Link to="/">MAIN</Link>
                  </li>

                  <li className="thisStyle description-breadcrumbs">
                    CONTACT US
                  </li>
                </ul>
                <Breadcrumbs />
              </div>
              <h2 className="title-conferences title-contact-us">Contact us</h2>
              <div className="line-conferences line-contact-us">
                <span className="line-about"></span>
              </div>
            </div>
          </section>
          <section>
            <div className="container">
              <div className="contact-us-container">
                <div className="address-block">
                  <ul className="contact-us-list">
                    <li>
                      <svg
                          width="50"
                          height="50"
                          viewBox="0 0 50 50"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M25.0007 25C26.1465 25 27.1277 24.5916 27.9444 23.775C28.7611 22.9583 29.1687 21.9777 29.1673 20.8333C29.1673 19.6875 28.759 18.7062 27.9423 17.8895C27.1256 17.0729 26.1451 16.6652 25.0007 16.6666C23.8548 16.6666 22.8736 17.075 22.0569 17.8916C21.2402 18.7083 20.8326 19.6888 20.834 20.8333C20.834 21.9791 21.2423 22.9604 22.059 23.777C22.8757 24.5937 23.8562 25.0013 25.0007 25ZM25.0007 40.3125C29.2368 36.4236 32.3791 32.8902 34.4277 29.7125C36.4763 26.5347 37.5006 23.7138 37.5006 21.25C37.5006 17.4652 36.2937 14.3666 33.8798 11.9541C31.4659 9.54163 28.5062 8.33468 25.0007 8.33329C21.4937 8.33329 18.5333 9.54024 16.1194 11.9541C13.7055 14.368 12.4993 17.4666 12.5007 21.25C12.5007 23.7152 13.525 26.5368 15.5736 29.7145C17.6222 32.8923 20.7645 36.425 25.0007 40.3125ZM25.0007 45.052C24.7229 45.052 24.4451 45 24.1673 44.8958C23.8895 44.7916 23.6465 44.6527 23.4382 44.4791C18.3687 40 14.584 35.8416 12.084 32.0041C9.58398 28.1666 8.33398 24.5819 8.33398 21.25C8.33398 16.0416 10.0097 11.8923 13.3611 8.80204C16.7125 5.71176 20.5923 4.16663 25.0007 4.16663C29.4104 4.16663 33.2909 5.71176 36.6423 8.80204C39.9937 11.8923 41.6687 16.0416 41.6673 21.25C41.6673 24.5833 40.4173 28.1687 37.9173 32.0062C35.4173 35.8437 31.6326 40.0014 26.5632 44.4791C26.3548 44.6527 26.1118 44.7916 25.834 44.8958C25.5562 45 25.2784 45.052 25.0007 45.052Z"
                            fill="#1089F1"
                        />
                      </svg>
                      <div>
                        <p className="address-item">Location</p>
                        <p>Hartigova 2660/141, 130 00 Prague - Žižkov</p>
                      </div>
                    </li>
                    <li>
                      <svg
                          width="50"
                          height="50"
                          viewBox="0 0 50 50"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M33.2285 45.8334L24.3744 36.9792L27.291 34.0625L33.2285 40L44.9994 28.2292L47.916 31.1459L33.2285 45.8334ZM24.9994 22.9167L41.666 12.5H8.33269L24.9994 22.9167ZM24.9994 27.0834L8.33269 16.6667V37.5H19.0619L23.2285 41.6667H8.33269C7.18685 41.6667 6.2056 41.2584 5.38894 40.4417C4.57227 39.625 4.16463 38.6445 4.16602 37.5V12.5C4.16602 11.3542 4.57435 10.373 5.39102 9.55629C6.20769 8.73963 7.18824 8.33199 8.33269 8.33338H41.666C42.8119 8.33338 43.7931 8.74171 44.6098 9.55838C45.4264 10.375 45.8341 11.3556 45.8327 12.5V21.5625L41.666 25.7292V16.6667L24.9994 27.0834Z"
                            fill="#1089F1"
                        />
                      </svg>
                      <div>
                        <p className="address-item">
                          Contact | General Inquiries
                        </p>
                        <p>
                          <a href="mailto:general@bcf-events.com">
                            general@bcf-events.com
                          </a>
                        </p>
                      </div>
                    </li>
                    <li>
                      <svg
                          width="50"
                          height="50"
                          viewBox="0 0 50 50"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M12.5 6.25V12.5H6.25V6.25H12.5ZM3.125 3.125V15.625H15.625V3.125H3.125ZM28.125 10.9375V17.1875H21.875V10.9375H28.125ZM18.75 7.8125V20.3125H31.25V7.8125H18.75ZM12.5 25V31.25H6.25V25H12.5ZM3.125 21.875V34.375H15.625V21.875H3.125Z"
                            fill="#1089F1"
                        />
                        <path
                            d="M34.375 15.625V25H25V34.375H15.625V46.875H46.875V15.625H34.375ZM28.125 28.125H34.375V34.375H28.125V28.125ZM25 43.75H18.75V37.5H25V43.75ZM34.375 43.75H28.125V37.5H34.375V43.75ZM43.75 43.75H37.5V37.5H43.75V43.75ZM43.75 34.375H37.5V28.125H43.75V34.375ZM37.5 25V18.75H43.75V25H37.5Z"
                            fill="#1089F1"
                        />
                      </svg>

                      <div>
                        <p className="address-item">
                          Media Partnership And Promotion
                        </p>
                        <p>
                          <a href="mailto:artyom.davydov@bcfgroup.eu">
                            artyom.davydov@bcfgroup.eu
                          </a>
                        </p>
                      </div>
                    </li>
                    <li>
                      <svg
                          width="49"
                          height="49"
                          viewBox="0 0 49 49"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M29.1454 7.26002C29.1974 7.06569 29.2872 6.8835 29.4096 6.72387C29.532 6.56424 29.6847 6.4303 29.8589 6.32969C30.0331 6.22908 30.2254 6.16378 30.4248 6.13753C30.6243 6.11127 30.8269 6.12457 31.0212 6.17666C33.8599 6.9173 36.4498 8.40127 38.5243 10.4757C40.5987 12.5502 42.0827 15.1401 42.8233 17.9788C42.8754 18.1731 42.8887 18.3757 42.8625 18.5752C42.8362 18.7746 42.7709 18.9669 42.6703 19.1411C42.5697 19.3153 42.4358 19.468 42.2761 19.5904C42.1165 19.7128 41.9343 19.8026 41.74 19.8546C41.6106 19.8885 41.4775 19.9059 41.3438 19.9062C41.0063 19.9062 40.6784 19.7948 40.4108 19.5892C40.1432 19.3835 39.9511 19.0953 39.8642 18.7693C39.2601 16.452 38.049 14.3377 36.3557 12.6443C34.6623 10.951 32.548 9.73985 30.2307 9.1358C30.0362 9.08403 29.8538 8.99441 29.694 8.87209C29.5341 8.74977 29.4 8.59713 29.2992 8.42291C29.1984 8.24869 29.1329 8.05631 29.1066 7.85677C29.0802 7.65723 29.0934 7.45445 29.1454 7.26002ZM28.6995 15.2608C31.339 15.9652 33.0348 17.661 33.7392 20.3005C33.8261 20.6266 34.0182 20.9148 34.2858 21.1204C34.5534 21.326 34.8813 21.4375 35.2188 21.4375C35.3525 21.4371 35.4856 21.4198 35.615 21.3858C35.8093 21.3338 35.9915 21.2441 36.1511 21.1216C36.3108 20.9992 36.4447 20.8466 36.5453 20.6724C36.6459 20.4982 36.7112 20.3059 36.7375 20.1064C36.7637 19.907 36.7504 19.7043 36.6983 19.51C35.7183 15.8427 33.1573 13.2817 29.49 12.3017C29.2957 12.2498 29.0931 12.2366 28.8937 12.263C28.6943 12.2894 28.5021 12.3548 28.328 12.4555C28.1539 12.5562 28.0013 12.6902 27.879 12.8499C27.7567 13.0095 27.6671 13.1917 27.6152 13.386C27.5632 13.5803 27.5501 13.7829 27.5765 13.9823C27.6029 14.1816 27.6683 14.3739 27.769 14.548C27.8697 14.722 28.0037 14.8746 28.1634 14.9969C28.323 15.1192 28.5052 15.2089 28.6995 15.2608ZM44.3833 33.5114C44.042 36.105 42.7683 38.4857 40.8 40.2088C38.8317 41.9319 36.3035 42.8797 33.6875 42.875C18.4899 42.875 6.12502 30.5101 6.12502 15.3125C6.12033 12.6965 7.06805 10.1683 8.79118 8.20001C10.5143 6.23172 12.895 4.95799 15.4886 4.6167C16.1445 4.53662 16.8086 4.67079 17.382 4.9992C17.9553 5.32761 18.4071 5.83263 18.6698 6.43888L22.7123 15.4637V15.4867C22.9134 15.9507 22.9965 16.4574 22.9541 16.9614C22.9117 17.4654 22.7451 17.9511 22.4692 18.375C22.4347 18.4267 22.3984 18.4745 22.3601 18.5224L18.375 23.2463C19.8087 26.1595 22.8558 29.1799 25.8073 30.6173L30.4661 26.6533C30.5119 26.6148 30.5598 26.5791 30.6097 26.5461C31.0333 26.2636 31.5206 26.0912 32.0276 26.0444C32.5346 25.9976 33.0452 26.0779 33.5133 26.2781L33.5382 26.2896L42.5554 30.3302C43.1627 30.592 43.6689 31.0434 43.9984 31.6168C44.3279 32.1902 44.4629 32.8549 44.3833 33.5114ZM41.3438 33.1286H41.3227L32.3266 29.0995L27.6659 33.0635C27.6207 33.1018 27.5734 33.1376 27.5242 33.1707C27.0835 33.4647 26.5741 33.6394 26.0457 33.6776C25.5173 33.7158 24.988 33.6164 24.5096 33.3889C20.9245 31.6567 17.351 28.1099 15.6169 24.5631C15.3872 24.0882 15.2842 23.562 15.3177 23.0355C15.3512 22.509 15.5202 22.0001 15.8083 21.5581C15.8407 21.5062 15.8772 21.4569 15.9174 21.4107L19.9063 16.681L15.8867 7.68494C15.886 7.6773 15.886 7.66961 15.8867 7.66197C14.0306 7.9041 12.3263 8.81455 11.0932 10.2228C9.86002 11.6311 9.1825 13.4406 9.18752 15.3125C9.19461 21.8081 11.7781 28.0357 16.3712 32.6288C20.9643 37.2219 27.1919 39.8054 33.6875 39.8125C35.5582 39.8189 37.3673 39.1438 38.7764 37.9133C40.1854 36.6828 41.0981 34.9812 41.3438 33.1267V33.1286Z"
                            fill="#1089F1"
                        />
                      </svg>
                      <div>
                        <p className="address-item">Phone</p>
                        <p className="phone-contact-us">
                          <strong>General</strong> +420 214 214 720
                        </p>
                        <p className="phone-contact-us">
                          <strong>Marketing Department</strong> +420 228 227 162
                        </p>
                        <p className="phone-contact-us">
                          <strong>Production Department</strong> +420 228 227 163
                        </p>
                        <p className="phone-contact-us">
                          <strong>Operations Department</strong> +420 228 227 164
                        </p>
                      </div>
                    </li>
                    <li className="social-contact-us">
                      <a target="_blank" rel="noreferrer noopener" href="https://www.facebook.com/bcfgroup.eu">
                        <img src={require('../../assets/images/6.png')} alt="" />
                      </a>
                      <a target="_blank" rel="noreferrer noopener" href="https://twitter.com/BCFgroupeu">
                        <img src={require('../../assets/images/x.png')} alt="" />
                      </a>
                      <a target="_blank" rel="noreferrer noopener" href="https://www.instagram.com/bcf.event/">
                        <img src={require('../../assets/images/3.png')} alt="" />
                      </a>
                      <a target="_blank" rel="noreferrer noopener" href="https://www.linkedin.com/company/business-conference-facilitation/">
                        <img src={require('../../assets/images/4.png')} alt="" />
                      </a>
                    </li>

                  </ul>
                </div>
                <div className="form-block form-block-pc">
                  <form className="form-contact-us" onSubmit={(e) =>
                      postMessageToSlack(e, "bank-transfer")
                  }>
                    <h3>
                      Is the answer to your question missing? Get in touch with us.
                    </h3>
                    <label htmlFor="mobile_nameInput">Full name*</label>
                    <input
                        id="mobile_nameInput"
                        name="name"
                        value={slackBody.name}
                        onChange={(e) => handleEmail(e)}
                        required
                    />
                    <label htmlFor="mobile_emailInput">Email*</label>
                    <input
                        id="mobile_emailInput"
                        name="email"
                        value={slackBody.email}
                        onChange={(e) => handleEmail(e)}
                        type="email"
                        required
                    />
                    <label htmlFor="mobile_subjectInput">Subject*</label>
                    <input
                        name="subject"
                        id="mobile_subjectInput"
                        value={slackBody.subject}
                        onChange={(e) => handleEmail(e)}
                        required
                    />
                    <label htmlFor="mobile_messageArea">Your message*</label>
                    <textarea
                        id="mobile_messageArea"
                        value={slackBody.message}
                        onChange={(e) => handleEmail(e)}
                        name="message"
                        required
                    ></textarea>
                    <button type="submit" className="button-contact-us">
                      { isLoading ? <ThreeDots  height="40" width="40" color="white" /> : "Request" }
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div className="container">
              <form className="form-bank"
                    onSubmit={(e) =>
                        postMessageToSlack(e, "bank-transfer")
                    }
              >
              </form>
            </div>
          </section>
          <section>
            <div className="container map-container">
              <MapContainer center={center} zoom={13} style={{ height: 300, width: "100%" }}>
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                <Marker position={center}>
                  <Popup>A pretty CSS popup.<br />Easily customizable.</Popup>
                </Marker>
              </MapContainer>
            </div>
          </section>
        </main>
        <Footer />
      </div>
  );
}

export default Contact;
